import { Component } from "react";
import { getFileByFileId, loadDrive } from "./GoogleDriveApi";
import parameters from "../../config/parameters";
import axios from 'axios';
import httpRequest from "./httpRequests"

/**
 * Get all fiel's in folder.
 * @param {String} folderId Id of the folder.
 * @param {Function} callback Get all files of folder.
 */
const getFoldersApi = (folderId,resourceKey, callback) => {
  const retrievePageOfFiles = function() {
    axios.get("api/getFiles" + httpRequest.getUrlQuery()+ "&fileId=" + folderId + "&resourceKey=" + resourceKey)
    .then(resp => {
        let result = resp.data;
        if (result && result !== "undefined") {
          callback(result);
        }
    });
  };

  const getFile = () => {
    retrievePageOfFiles();
  };

  getFile();
};

class SearchDriveAPI extends Component {
  constructor(props) {
    super(props);
    this.searchFiles = this.searchFiles.bind(this);
    this.buildTreeFolders = this.buildTreeFolders.bind(this);
    this.state = {
      retrieveFilesSearch: false
    }
  }

  /**
   * Get all file's in folder.
   * @param {String} folderId Id of the folder.
   * @param {Function} callback Get all files of folder.
   */
   searchFiles(folderId, searchText, callback) {
    const retrieveFilesSearch = (listFolderId, searchText) => {
      console.log("searchFiles this.props.itemList", this.props.itemList)
      let listFolderIdFilter = [];
      if (Object.keys(this.props.itemList).length)
        listFolderIdFilter = Object.values(this.props.itemList).filter((file) => file.title.toLowerCase().includes(searchText.toLowerCase()));
      callback(listFolderIdFilter);
    };

    const getFielsearch = (folderId) => {
          retrieveFilesSearch(this.props.navigationListSearch, searchText);
    };
    getFielsearch(this.props.navigationListSearch)
  }

  buildTreeFolders(folderId, resourceKey,parent, callback) {
    let navigationListSearch = this.props.navigationListSearch ? this.props.navigationListSearch: {};
    getFileByFileId(folderId, resourceKey,item => {
      if (item) {
        if (item.mimeType === parameters["TYPE_FOLDER"]) {
          if (!navigationListSearch[folderId]) {
            navigationListSearch[folderId] =  item ;
            this.props.updateNavigationListSearch(navigationListSearch);
          }
          getFoldersApi(item.id,item.resourceKey, children => {
            children.map(child => {
              if (child)
                this.buildTreeFolders(child.id, child.resourceKey,item);
            });
          });
        }
        else {
          navigationListSearch[folderId] =  item
          this.props.updateNavigationListSearch(navigationListSearch);
      }
    }
    },false);
    return callback ? callback(navigationListSearch) : navigationListSearch;
  }
}

export default SearchDriveAPI;



// WEBPACK FOOTER //
// ./src/widget/api/SearchDriveApi.js